import React, { useMemo } from 'react';

import { Logo } from '../../../components/general';
import { PageWrapper } from '../../../components/layout/content';

import { useWindowWidth } from '../../../hooks/useWindowWidth';

import { getBpWidth } from '../../../utils';

interface Props {
  title: string;
  heading: string;
  children: React.ReactNode;
  isLoading?: boolean;
}

const OnboardingPage: React.FC<Props> = (props) => {
  const { title, heading, children, isLoading } = props;

  const windowWidth = useWindowWidth();
  const isMobileDevice = useMemo(
    () => windowWidth < getBpWidth('sm'),
    [windowWidth],
  );

  const s3Folder =
    'https://crowdclip-media-assets.s3.ap-southeast-2.amazonaws.com/onboarding/';
  const backgroundImage = s3Folder + 'onboarding-background.png';
  const imagePath =
    s3Folder + `onboarding-gif-${isMobileDevice ? 'mobile' : 'desktop'}`;

  return (
    <React.Fragment>
      <div
        className="fixed top-0 left-0 w-full h-full bg-cover bg-center -z-10"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />

      <PageWrapper type="onboarding" isLoading={isLoading} title={title} noTips>
        <div className="w-[var(--page-width)] sm:w-[75vw] sm:min-h-[75vh] flex flex-col-reverse sm:flex-row m-auto bg-black-overlay-600 rounded-md sm:rounded-l-md sm:rounded-r-none">
          <div className="w-full sm:w-[60%] h-fit sm:min-h-[75vh] flex flex-col items-center justify-center p-6 sm:p-10 gap-4">
            <Logo />

            <div className="text-center font-bold text-xl sm:text-2xl text-white">
              {heading}
            </div>

            <div className="w-full flex flex-col gap-4">{children}</div>
          </div>

          <div className="w-full sm:w-[40%] h-[calc(var(--page-width)_*_9_/_16)] sm:h-auto object-cover bg-black rounded-t-md sm:rounded-none overflow-hidden">
            <video
              className="w-full h-full object-cover"
              loop
              autoPlay
              muted
              playsInline
              onError={(e) => {
                const video = e.currentTarget;
                video.style.display = 'none';
                const fallback = video.nextSibling as HTMLElement | null;
                if (fallback) fallback.style.display = 'block';
              }}
            >
              <source src={imagePath + '.webm'} type="video/webm" />
              Your browser does not support the webm format.
            </video>
            <img
              className="w-full h-full object-cover"
              src={imagePath + '.gif'}
              alt="Onboarding Graphic"
              style={{ display: 'none' }}
            />
          </div>
        </div>
      </PageWrapper>
    </React.Fragment>
  );
};

export default OnboardingPage;
